import type { IMediaItemSchema, IMediaSchema } from '../interface';

function byMediumGuid(schema: IMediaSchema, mediumGuid: string): IMediaItemSchema | null {
    return schema.media.find(media => media.sourceGuid === mediumGuid) ?? null;
}

export default Object.freeze({
    mediaItem: {
        byMediumGuid,
    },
});
